import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Sun, Bell } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

interface HeaderProps {
  title?: string;
  showGreeting?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ title, showGreeting = false }) => {
  const { isDark, toggleTheme } = useTheme();
  const { user } = useAuth();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Buenos días';
    if (hour < 20) return 'Buenas tardes';
    return 'Buenas noches';
  };

  const getFirstName = () => {
    return user?.name?.split(' ')[0] || 'Usuario';
  };

  return (
    <header className="sticky top-0 z-40 px-6 py-4 pt-safe backdrop-blur-sm bg-[var(--color-bg)]/80">
      <div className="flex items-center justify-between max-w-6xl mx-auto">
        <div className="flex-1">
          {showGreeting ? (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
            >
              <p className="text-sm text-[var(--color-text-muted)]">{getGreeting()}</p>
              <h1 className="text-2xl font-display font-semibold text-[var(--color-text)]">
                {getFirstName()} 👋
              </h1>
            </motion.div>
          ) : (
            <motion.h1
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-xl font-display font-semibold text-[var(--color-text)]"
            >
              {title}
            </motion.h1>
          )}
        </div>

        <div className="flex items-center gap-2">
          <motion.button
            whileTap={{ scale: 0.9 }}
            onClick={() => {}}
            className="p-3 rounded-xl hover:bg-[var(--color-surface)] transition-colors"
            aria-label="Notificaciones"
          >
            <Bell size={22} className="text-[var(--color-text-muted)]" />
          </motion.button>

          <motion.button
            whileTap={{ scale: 0.9 }}
            onClick={toggleTheme}
            className="p-3 rounded-xl hover:bg-[var(--color-surface)] transition-colors"
            aria-label={isDark ? 'Activar modo claro' : 'Activar modo oscuro'}
          >
            {isDark ? (
              <Sun size={22} className="text-amber-400" />
            ) : (
              <Moon size={22} className="text-[var(--color-text-muted)]" />
            )}
          </motion.button>
        </div>
      </div>
    </header>
  );
};
